import { render, staticRenderFns } from "./ReportForm.vue?vue&type=template&id=70791170&"
import script from "./ReportForm.vue?vue&type=script&lang=js&"
export * from "./ReportForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports